import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Bouillotte = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67.88 117.29">
  <G fill={color}>
    <Path d="M55.01,30.29c-1.42-.36-2.81-1.29-3.9-2.62l-.6-.73c-1.92-2.33-2.5-5.56-1.52-8.42l4.42-12.83c.45-1.31.24-2.76-.56-3.89s-2.11-1.8-3.5-1.8h-30.81c-1.39,0-2.69.67-3.5,1.8-.81,1.13-1.02,2.58-.56,3.89l4.42,12.83c1,2.9.43,6.05-1.52,8.41l-.61.74c-1.09,1.32-2.47,2.25-3.9,2.62-7.58,1.94-12.87,8.74-12.87,16.55v53.38c0,9.42,7.66,17.08,17.08,17.08h33.73c9.42,0,17.07-7.66,17.07-17.08v-53.38c0-7.81-5.29-14.61-12.87-16.55ZM18.16,53.65c0-2.37,1.92-4.3,4.3-4.3s4.3,1.92,4.3,4.3v37.37c0,2.37-1.92,4.3-4.3,4.3s-4.3-1.92-4.3-4.3v-37.37ZM41.13,53.65c0-2.37,1.92-4.3,4.3-4.3s4.3,1.92,4.3,4.3v37.37c0,2.37-1.92,4.3-4.3,4.3s-4.3-1.92-4.3-4.3v-37.37Z"/>
  </G>
</Svg>
);
};

export default Bouillotte;
